export function playSuccessChime() {
    try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();

        const notes = [
            { freq: 523.25, start: 0.00, dur: 0.18 },  // C5
            { freq: 659.25, start: 0.12, dur: 0.18 },  // E5
            { freq: 783.99, start: 0.24, dur: 0.30 },  // G5
        ];

        notes.forEach(({ freq, start, dur }) => {
            const osc  = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);

            osc.type = 'sine';
            osc.frequency.value = freq;

            const t = ctx.currentTime + start;
            gain.gain.setValueAtTime(0, t);
            gain.gain.linearRampToValueAtTime(0.25, t + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.001, t + dur);

            osc.start(t);
            osc.stop(t + dur);
        });

        // Close context after all notes finish
        setTimeout(() => ctx.close(), 1200);
    } catch { /* silently ignore if audio is blocked */ }
}
